import React from 'react';

// Styles
import { ButtonWrap, Icon } from './style';

export const IconButton = ({
  name = '',
  dir,
  src,
  // onClick,
  ...props
}: {
  name: string;
  dir?: string;
  src?: string;
  onClick?: () => void;
}) => {
  return (
    <ButtonWrap {...props}>
      {/* @ts-ignore */}
      <Icon name={name} {...{ dir, src }} priority />
    </ButtonWrap>
  );
};
